<template>
    <x-app class="layout-home-sample">
        <x-navbar :schema="schema.navbar"></x-navbar>
    
        <x-sidebar :schema="schema.navbar"></x-sidebar>

        <template v-slot:content>
            <transition name="fade" mode="out-in" appear>
                <x-page-view :schema="schema.pageview"></x-page-view>
            </transition>
        </template>

        <x-quickbar></x-quickbar>

        <x-footerbar :schema="schema.footerbar"></x-footerbar>
    </x-app>
</template>

<script>
export default {
    name: 'LayoutHomeSample',
    data() {
        return {
            schema: {
                navbar: {
                    color: 'primary',
                    logo: {
                        small: require('@/assets/imgs/logo/light/2.png'),
                        large: require('@/assets/imgs/logo/light/5.png'),
                        hint: 'XTPG'
                    },
                    left: [
                        {
                            type: 'button',
                            hint: 'Home',
                            icon: 'mdi-home-outline',
                            disabled: false,
                            class: 'hidden-sm-and-down',
                            to: { name: 'sample_home' }
                        },
                        {
                            type: 'button',
                            icon: 'mdi-dots-grid',
                            hint: 'Atalhos de Navegação',
                            disabled: false,
                            class: 'hidden-md-and-up',
                            click: this.$sidebarToggle
                        },
                        {
                            type: 'dropdown-navigation',
                            hint: 'Atalhos de Navegação',
                            icon: 'mdi-dots-grid',
                            disabled: false,
                            class: 'hidden-sm-and-down',
                            modulesPanel: {
                                title: 'navigation.modules.title',
                                minWidth: null,
                                maxWidth: null,
                                items: [
                                    {
                                        label: 'Clientes',
                                        hint: 'Clientes',
                                        icon: 'mdi-account-group',
                                        // image: require('@/assets/imgs/icons/18.png'),
                                        disabled: false,
                                        color: 'primary',
                                        to: { name: 'sample_customers' },
                                    },
                                    {
                                        label: 'Contatos',
                                        hint: 'Contatos',
                                        icon: 'mdi-account-box',
                                        // image: require('@/assets/imgs/icons/9.png'),
                                        disabled: false,
                                        color: 'primary',
                                        to: { name: 'sample_contacts' },
                                        // to: '/sample/login',
                                        // to: 'sample_login',
                                        // click: () => {
                                        //     console.log('Chamando minha função ou metodo!');
                                        // }
                                    },
                                    {
                                        label: 'Bancos',
                                        hint: 'Bancos',
                                        icon: 'mdi-bank',
                                        // image: require('@/assets/imgs/icons/7.png'),
                                        disabled: false,
                                        color: 'primary',
                                        to: { name: 'sample_banks' },
                                    },
                                    {
                                        label: 'Financeiro',
                                        hint: 'Financeiro',
                                        icon: 'mdi-calculator',
                                        // image: require('@/assets/imgs/icons/6.png'),
                                        disabled: false,
                                        color: 'primary',
                                        to: { name: 'sample_financial' },
                                    },
                                    {
                                        label: 'Relatórios',
                                        hint: 'Relatórios',
                                        icon: 'mdi-finance',
                                        // image: require('@/assets/imgs/icons/1.png'),
                                        disabled: false,
                                        color: 'primary',
                                        to: { name: 'sample_reports' },
                                    },
                                ]
                            },
                            historyPanel: {
                                title: 'navigation.history.title',
                                minWidth: null,
                                maxWidth: null,
                                items: [
                                    {
                                        label: 'Grupos de Usuários',
                                        hint: 'Grupos de Usuários',
                                        disabled: false,
                                        to: null
                                    },
                                    {
                                        label: 'Usuários',
                                        hint: 'Usuários',
                                        disabled: false,
                                        to: null
                                    },
                                    {
                                        label: 'Análises Gerenciais',
                                        hint: 'Análises Gerenciais',
                                        disabled: false,
                                        to: null
                                    },
                                    {
                                        label: 'Relatórios',
                                        hint: 'Relatórios',
                                        disabled: false,
                                        to: null
                                    },
                                ]
                            },
                        },
                        {
                            type: 'dropdown-items',
                            hint: 'Favoritos',
                            icon: 'mdi-star-outline',
                            disabled: false,
                            class: 'hidden-sm-and-down',
                            items: [
                                {
                                    label: 'Item 1',
                                    hint: null,
                                    icon: 'mdi-chevron-right-circle',
                                    disabled: false,
                                    to: null
                                },
                                {
                                    label: 'Item 2',
                                    hint: null,
                                    icon: 'mdi-chevron-right-circle',
                                    disabled: true,
                                    to: null
                                },
                            ]
                        }
                    ],
                    right: [
                        {
                            type: 'button',
                            hint: 'Minhas Conversas',
                            icon: 'mdi-chat-processing',
                            disabled: false,
                            class: 'd-none d-sm-flex',
                            badge: {
                                text: '5',
                            },
                            click: this.chatOpen,
                        },
                        {
                            type: 'dropdown-items',
                            hint: 'Mensagens',
                            icon: 'mdi-bell',
                            disabled: false,
                            class: 'd-none d-sm-flex',
                            badge: {
                                text: '5',
                                color: 'warning'
                            },
                            items: [
                                {
                                    label: 'Item 1',
                                    hint: null,
                                    icon: 'mdi-chevron-right-circle',
                                    disabled: false,
                                    to: null
                                },
                                {
                                    label: 'Item 2',
                                    hint: null,
                                    icon: 'mdi-chevron-right-circle',
                                    disabled: true,
                                    to: null
                                },
                            ]
                        },
                        {
                            type: 'button',
                            hint: 'Agenda',
                            icon: 'mdi-calendar-month-outline',
                            disabled: false,
                            class: 'd-none d-sm-flex',
                            click: this.taskListOpen
                        },
                        {
                            type: 'button',
                            hint: 'Principais Moedas',
                            icon: 'mdi-currency-usd',
                            disabled: false,
                            class: 'hidden-sm-and-down',
                            click: this.currencyMonitorOpen,
                        },
                        {
                            type: 'dropdown-user',
                            hint: null,
                            icon: null,
                            disabled: false,
                            user: {
                                username: 'MASTER',
                                firstname: 'MASTER',
                                fullname: 'MASTER ADMIN',
                                avatar: require('@/assets/imgs/user.png'),
                                profile: 'ADMIN'
                            },
                            items: [
                                {
                                    label: 'Meu Perfil',
                                    hint: null,
                                    icon: 'mdi-account',
                                    disabled: false,
                                    separator: true,
                                    to: null
                                },
                                {
                                    label: 'Alterar Senha',
                                    hint: null,
                                    icon: 'mdi-lock',
                                    disabled: false,
                                    separator: false,
                                    to: null
                                },
                                {
                                    label: 'Sair do Sistema',
                                    hint: null,
                                    icon: 'mdi-exit-to-app',
                                    disabled: false,
                                    separator: true,
                                    to: 'sample_login',
                                },
                            ]
                        },
                    ],
                },
                footerbar: {
                    color: 'four',
                    items: [
                        {
                            label: null,
                            hint: null,
                            icon: null,
                            image: require('@/assets/imgs/logo/light/8.png'),
                        },
                        {
                            label: 'Versão: 1.0.1',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                            // to: 'sample_login',
                            click: () => {
                                console.log('Chamando minha função ou metodo!');
                            }
                        },
                        {
                            label: 'Posição: 31/12/2022',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                        {
                            label: 'Atualizado: Há 5 min.',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                        {
                            label: 'Moeda: BRL',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                        {
                            label: 'Terça-Feira, 31 de dezembro de 2022',
                            hint: null,
                            icon: null,
                            class: 'hidden-sm-and-down',
                        },
                    ],
                    chat: {
                        label: 'Abrir Chat',
                        hint: 'Abrir Chat',
                        icon: 'mdi-chat-processing',
                        class: null,
                        click: this.chatOpen
                    },
                },
                pageview: {
                    tabs: {
                        onCloseAll: { name: 'sample_home' },
                    },
                    sidebar: {
                        open: true,
                        width: 240,
                        title: 'Assuntos Relacionados',
                        items: [
                            {
                                label: 'Clientes',
                                hint: null,
                                icon: 'mdi-account-group',
                                class: null,
                                to: 'sample_customers',
                            },
                            {
                                label: 'Contatos',
                                hint: null,
                                icon: 'mdi-account-box',
                                class: null,
                                to: 'sample_contacts',
                            },
                            {
                                label: 'Bancos',
                                hint: null,
                                icon: 'mdi-bank-outline',
                                class: null,
                                to: 'sample_banks',
                            },
                            {
                                label: 'Financeiro',
                                hint: null,
                                icon: 'mdi-calculator',
                                class: null,
                                to: 'sample_financial',
                            },
                            {
                                label: 'Relatórios',
                                hint: null,
                                icon: 'mdi-finance',
                                class: null,
                                to: 'sample_reports',
                            },
                        ]
                    },
                },
            },
        }
    },
    methods: {
        chatOpen() {
            this.$quickbarOpen('ChatMessages', {
                title: 'Meu Chat',
                icon: 'mdi-chat-processing',
                autoclose: false,
                overlay: false
            });
        },
        taskListOpen() {
            this.$quickbarOpen('TaskList', {
                title: 'Minhas Tarefas',
                icon: 'mdi-calendar-month-outline'
            });
        },
        currencyMonitorOpen() {
            this.$quickbarOpen('CurrencyMonitor', {
                title: 'Moedas',
                icon: 'mdi-currency-usd'
            });
        },
        redirectToHome() {
            this.$router.push({ name: 'sample_home' });
        },
    },
    watch: {
        schema: {
            deep: true,
            immediate: true,
            handler(newVal) {
                this.$store.commit('sample/SET_SCHEMA', newVal);
            },
        }
    },
}
</script>

<style scoped>
.fade-enter{
    opacity: 0;
}
.fade-enter-active{
    transition: all .4s ease;
}
</style>
